import './request-list-controller';
import './request-details-controller';
import './request-form-controller';
import './request-denials-incidents-controller';
import './request-items-controller';
import './request-items-detalhe-modal-controller';